import React from "react";

import categories from "../../data/faqs/index";
import { popularGroups, quickActions } from "../../data/home";
import CategoryGrid from "../../components/Help/CategoryGrid";
import ContactBand from "../../components/Help/ContactBand";
import HelpSearch from "../../components/Help/HelpSearch";
import PopularQuestions from "../../components/Help/PopularQuestions";
import QuickActions from "../../components/Help/QuickActions";

/**
 * /help. Block order follows the visual spec (section 4): hero with search and
 * quick actions, categories, popular questions, contact. The spec's store block
 * is left out on purpose -- the footer below already lists every store with its
 * address, WhatsApp and 360° tour, and the block had no photo to carry it.
 */
const Home = () => (
  <div className="hc-home">
    <header className="hc-hero">
      <div className="hc-container">
        <p className="hc-eyebrow">Help Center</p>
        <h1 className="hc-hero__title">Hai, ada yang bisa Kyou bantu?</h1>
        <p className="hc-hero__sub">
          Ketik pertanyaanmu di bawah, atau pilih kategori yang paling dekat sama kasus kamu. Kalau belum ketemu juga, Team Kyou siap bantu lewat chat.
        </p>
        <HelpSearch variant="hero" placeholder="Contoh: order Pre-Order aku kapan dikirim?" />
        <QuickActions actions={quickActions} />
      </div>
    </header>

    <section className="hc-section" aria-labelledby="hc-cats-title">
      <div className="hc-container">
        <h2 id="hc-cats-title" className="hc-section__title">
          Pilih kategori
        </h2>
        <p className="hc-section__note">Klik kategori yang paling dekat sama kasus kamu.</p>
        <CategoryGrid categories={categories} />
      </div>
    </section>

    <section className="hc-section hc-section--tight" aria-labelledby="hc-popular-title">
      <div className="hc-container">
        <h2 id="hc-popular-title" className="hc-section__title">
          Yang paling sering ditanya
        </h2>
        <PopularQuestions groups={popularGroups} />
      </div>
    </section>

    <ContactBand />
  </div>
);

export default Home;
